export enum FormInputType {
  TEXT = 'text',
  PASSWORD = 'password'
}
